//This is the default placeholder Markup for the App

const placeholder=`# Hello 👋

Markdown is a markdown editor ✍

## 🤷‍♂️ What can you write here

1. Code
  * eg: \`<div>Markdown Editor Online</div>\` or
  *eg:

  \`\`\`bash
  npm install marked
  \`\`\`

2. Blockquote
	* eg: 
> Blockquote

3. Different Text Style
  * **Bold**
  * *Italic*
  * ~~Strikethrough~~
  
4. Tables

    | Name          | Age           | Salary|
    | ------------- |:-------------:| -----:|
    | Mao           | 28            | $17000|
    | Ha            | 24            | $11000|
    | Markdown      | 16            | $9000 |

5. Images
  
    ![React](https://standardbeagle.com/wp-content/uploads/2017/07/Markdown-600x400.png)


## 🛸 Technologies Used

*  React.js
*  SCSS
*  JavaScript

`;

export default placeholder;